<template>
  <AddForm :mode="mode" @createItem="handleCreate" />

  <ul :class="listClass">
    <test-drag>
      <project-item
        v-for="project in updateFilter"
        :key="project.id"
        :project="project"
        :id="project.id"
        :mode="mode"
        @toggleComplete="handleComplete"
        @deleteItem="handleDelete"
      ></project-item>
    </test-drag>

    <TheNav
      :mode="mode"
      :filterBy="filterBy"
      :projects="projects"
      :updateFilter="updateFilter"
      @filterUpdate="handleFilter"
      @delComp="handleDelComp"
    />

    <p v-if="!projects.length">目前沒有待辦清單</p>
    <br />
    <br />
  </ul>
</template>

<script>
import TestDrag from "./TestDrap";
import ProjectItem from "./ProjectItem";
import AddForm from "@/components/AddForm";
import TheNav from "@/components/TheNav";

export default {
  props: ["mode"],
  data() {
    return {
      projects: [],
      filterBy: "all",
    };
  },
  created() {
    if (process.env.VUE_APP_URI) {
      fetch(process.env.VUE_APP_URI)
        .then((res) => res.json())
        .then((data) => (this.projects = data))
        .catch((e) => console.log(e));
    }

    this.projects = JSON.parse(localStorage.getItem("items")) || [];
  },
  components: {
    ProjectItem,
    AddForm,
    TheNav,
    TestDrag,
  },

  methods: {
    handleComplete(id) {
      const item = this.projects.find((project) => project.id == id);
      item.complete = !item.complete;
      localStorage.setItem(`items`, JSON.stringify(this.projects));
    },

    handleDelete(id) {
      this.projects = this.projects.filter((project) => project.id != id);
      localStorage.setItem(`items`, JSON.stringify(this.projects));
    },

    handleCreate(project) {
      this.projects.push(project);
      localStorage.setItem(`items`, JSON.stringify(this.projects));
    },

    handleFilter(event) {
      this.filterBy = event;
    },

    handleDelComp(item) {
      this.projects = item;
      localStorage.setItem(`items`, JSON.stringify(this.projects));
    },
  },

  computed: {
    updateFilter() {
      if (this.filterBy === "complete") {
        return this.projects.filter((project) => project.complete);
      }
      if (this.filterBy === "active") {
        return this.projects.filter((project) => !project.complete);
      }
      return this.projects;
    },

    listClass() {
      return this.mode === "light" ? "list-light" : "list-dark";
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  width: 54rem;
  // min-height: 44rem;
  border-radius: 6px;
  box-shadow: 0 2.5rem 3rem rgba(0, 0, 0, 0.08);
  margin-top: 2.4rem;
  z-index: 999;

  @media only screen and (max-width: 600px) {
    max-width: 32rem;
  }
}

.list-light {
  background-color: #ffff;
}

.list-dark {
  background-color: #25273d;
}

p {
  font-size: 3rem;
  color: #494c6b;
  text-align: center;
  margin-top: 10rem;
  font-weight: 700;
  font-style: italic;
}
</style>
